import AuthSideInfo from 'src/components/Auth/AuthSideInfo';
import SignupWrapper from 'src/components/Auth/SignupWrapper';
import Seo from 'src/components/Seo';
import seoConfig from '../../seo.json';
import RecruiterAuthSideInfo from 'src/components/Auth/RecruiterAuthSideInfo';
import { isRecruiterSide, isUniversitySide } from 'src/config/env.config';
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const SignUp = () => {
	const navigate = useNavigate();
	const isMobile = useMediaQuery('(max-width:960px)');
	const seoInfo = isRecruiterSide ? seoConfig['sign-up-recruiter'] : seoConfig['sign-up-js'];

	useEffect(() => {
		if (isUniversitySide) {
			navigate(`/signin`);
		}
	}, [isRecruiterSide, isUniversitySide, navigate]);

	return (
		<>
			<Seo
				title={seoInfo.title}
				description={seoInfo.description}
				ogImage={
					isRecruiterSide
						? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/Hire_OG_Lanidng_Page_18f7d7326f.png'
						: undefined
				}
			/>

			<div
				style={{
					gridTemplateColumns: '',
				}}
				className={`min-h-[670px] h-[100%] block md:grid dark:bg-[#111e2c] bg-[#F7F9FB] grid-cols-[2fr_1fr]`}
			>
				{isRecruiterSide ? <RecruiterAuthSideInfo /> : <AuthSideInfo />}
				{isRecruiterSide && isMobile ? null : <SignupWrapper />}
			</div>
		</>
	);
};

export default SignUp;
